import Help from './components/Help';
import './assets/Help.css';

export default Help;



// WEBPACK FOOTER //
// ./src/routes/Help/index.js